(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hp-shop"] && !Shopify.designMode) return;
  try {
    
  function initializeShopPrices(root) {
    root.querySelectorAll('.hp-shop__card').forEach((card) => {
      const form = card.querySelector('.hp-shop__form');
      const dataElement = card.querySelector('.hp-shop__price-data');
      const priceElement = card.querySelector('.hp-shop__price');

      if (!form || !dataElement || !priceElement || card.dataset.priceReady) {
        return;
      }

      const variants = JSON.parse(dataElement.textContent);
      card.dataset.priceReady = 'true';
      priceElement.setAttribute('aria-live', 'polite');

      function updatePrice() {
        const variantInput = form.querySelector('[name="id"]');
        const variant = variants[variantInput?.value];
        if (!variant) return;

        const planInputs = Array.from(
          form.querySelectorAll('input[name="selling_plan"]')
        );

        // Prevent selecting a plan unavailable for this variant.
        planInputs.forEach((input) => {
          input.disabled = input.value !== '' && !variant.plans[input.value];
        });

        let selectedPlan = planInputs.find((input) => input.checked);

        if (!selectedPlan || selectedPlan.disabled) {
          if (selectedPlan) selectedPlan.checked = false;
          selectedPlan = planInputs.find((input) => !input.disabled);
          if (selectedPlan) selectedPlan.checked = true;
        }

        const planId = selectedPlan?.value;
        const pricing = planId ? variant.plans[planId] : variant;

        const button = form.querySelector('[type="submit"]');
        if (button) {
          if (button.dataset.originalDisabled === undefined) {
            button.dataset.originalDisabled = String(button.disabled);
          }
          button.disabled =
            button.dataset.originalDisabled === 'true' ||
            (planInputs.length > 0 && !selectedPlan);
        }

        if (!pricing) return;

        priceElement.replaceChildren(document.createTextNode(pricing.price));

        if (pricing.compare) {
          const compare = document.createElement('s');
          compare.className = 'hp-shop__compare';
          compare.textContent = pricing.compare;
          priceElement.appendChild(compare);
        }
      }

      form.addEventListener('change', updatePrice);
      updatePrice();
    });
  }

  initializeShopPrices(document);

  document.addEventListener('shopify:section:load', (event) => {
    initializeShopPrices(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
